/**
 * Print Swatches Toggle Action
 * Triggered by: arc:action:printSwatchesToggle
 *
 * Dispatches a 'print-swatches:toggle' window event which the printSwatchesDrawer
 * Alpine component listens for to open/close the print swatches drawer.
 *
 * Usage (button-link custom_actions field):
 *   printSwatchesToggle
 */

export const runPrintSwatchesToggle = async (data = {}) => {
  try {
    window.dispatchEvent(new CustomEvent('print-swatches:toggle', { detail: data }));

    return {
      success: true,
      message: 'Print swatches drawer toggled successfully',
    };
  } catch (error) {
    console.error('Error toggling print swatches drawer:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export default runPrintSwatchesToggle;
